export default __webpack_public_path__ + "static/media/gm.740c26da.svg";